module.exports = __webpack_public_path__ + "img/03-green.283b8bfd.svg";